import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/empty.vue").then(m => m.default || m)),
  pages: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/pages.vue").then(m => m.default || m))
}